<template>
  <div class="info">
    <h4 class="title">个人信息</h4>
    <div class="clo">
      <Row>
        <Col span="6">
          用户名: {{info.userName}}
        </Col>
        <Col span="6">
          注册时间: {{info.registerTime}}
        </Col>
        <Col span="6">
          登录次数: {{info.loginNum}}
        </Col>
      </Row>
      <Row>
        <Col span="24">首次访问地址：{{unescapeUrl(info.fVisitUrl)}}</Col>
      </Row>
      <Row>
        <Col span="24">注册来源地址：{{unescapeUrl(info.fromUrl)}}</Col>
      </Row>
      <!--      <Row>-->
      <!--        <Col span="6">-->
      <!--          用户名: {{info.userName}}-->
      <!--        </Col>-->
      <!--        <Col span="6">-->
      <!--          用户ID: {{info.uid}}-->
      <!--        </Col>-->
      <!--        <Col span="6"></Col>-->
      <!--        <Col span="6"></Col>-->
      <!--      </Row>-->
      <!--      <Row>-->
      <!--        <Col span="6">-->
      <!--          手机号: {{info.mobilePhone}}-->
      <!--        </Col>-->
      <!--        <Col span="6">-->
      <!--          注册时间: {{info.registerTime}}-->
      <!--        </Col>-->
      <!--        <Col span="6">-->
      <!--          登录次数: {{info.loginNum}}-->
      <!--        </Col>-->
      <!--        <Col span="6"></Col>-->
      <!--      </Row>-->
    </div>

    <h4 class="title">开课信息</h4>
    <Table :loading="loading" border :columns="columns" :data="tblData"></Table>
  </div>
</template>

<script>
  export default {
    name: "info",
    props: {
      uid: {
        type: Number,
        default: () => {
        }
      },
      info: {
        type: Object,
        default: () => {
        }
      }
    },
    data() {
      return {
        orderType: [
          {
            // value: '未下单',
            // color: '#2db7f5'
          }, {
            value: '未开通',
            color: '#bebebe'
          }, {
            value: '未开通',
            color: '#bebebe'
          }, {
            value: '已开通',
            color: '#19be6b'
          }, {
            value: '已退款',
            color: '#a569f1'
          }
        ],
        orderType2: [
          {
            value: '未开通',
            color: '#bebebe'
          }, {
            value: '已开通',
            color: '#19be6b'
          }
        ],
        id: null,
        loading: true,
        tblData: [],
        columns: [
          {
            title: "订单编号",
            key: "orderID",
            width: 170
          },
          // {
          //   title: "课程名称",
          //   key: "classNameList",
          //   width: 250,
          //   render: (h, params) => {
          //     const arr = params.row.classNameList;
          //     const newArr = [];
          //     if (arr) {
          //       arr.forEach((info) => {
          //         console.log(info);
          //         newArr.push(h('p', {
          //           style: {
          //             marginRight: '4px',
          //             marginBottom: '4px',
          //           },
          //         }, info))
          //       });
          //     }
          //     return h('div', {
          //       style: {
          //         marginTop: '4px',
          //       },
          //     }, newArr)
          //   }
          // },
          {
            title: "课程名称",
            key: "className",
          },
          {
            title: "订单金额",
            key: "classMoney",
            width: 100
          },
          {
            title: "支付金额",
            key: "payMoney",
            width: 100
          },
          {
            title: "订单状态",
            key: "payStatus",
            width: 100,
            render: (h, params) => {
              if (params.row.productType === 1) {
                return h("span", {
                  style: {
                    color: this.orderType[params.row.payStatus].color,
                  }
                }, this.orderType[params.row.payStatus].value);
              } else if (params.row.productType === 2) {
                return h("span", {
                  style: {
                    color: this.orderType2[params.row.payStatus].color,
                  }
                }, this.orderType2[params.row.payStatus].value);
              }
            }
          },
          {
            title: "下单时间",
            key: "addTime",
            width: 200
          },
          {
            title: "支付/退款时间",
            key: "action",
            width: 200,
            render: (h, params) => {
              // console.log(params);

              if (params.row.productType === 1) {
                if (params.row.payStatus === 4) {
                  return h("span", {}, params.row.refoundTime);
                } else if (params.row.payStatus === 1 || params.row.payStatus === 2) {
                  return h("span", {}, '');
                } else {
                  return h("span", {}, params.row.payTime);
                }
              } else if (params.row.productType === 2) {
                if (params.row.payStatus === 0) {
                  return h("span", {}, '');
                } else {
                  return h("span", {}, params.row.payTime);
                }
              }


            }
          },
        ]
      }
    },
    methods: {
      getInfo(uid) {
        const params = {
          uid: uid
        };
        this.$store.dispatch('effect/studentInfo', params).then(res => {
          this.loading = false;
          this.tblData = res;
        })
      },
      unescapeUrl(url) {
        return unescape(unescape(url))
      }
    },
    created() {
      this.id = JSON.stringify(this.uid);
      this.getInfo(this.id);
    },
    destroyed() {

    }
  }
</script>
<style scoped lang="scss">
  .info {
    .title {
      /*font-size: 16px;*/
      margin-bottom: 10px;
    }

    .clo {
      margin-bottom: 15px;

      .ivu-col {
        line-height: 30px;
      }
    }
  }
</style>